import React, { useState, useEffect } from "react";
import axios from "axios";
import "../Styles/style.css";
import BiddingPosts from "./biddingPosts";
import { baseUrl } from "../../api/ipconfig";
import Skeleton from "@mui/material/Skeleton";

export default function BiddingBody() {
  const [auctionPosts, setAuctionPosts] = useState([]);

  const [loading, setLoading] = useState(true);

  const PostTypeId = 3;

  const fetchAuctionPosts = async () => {
    try {
      // const token = localStorage.getItem("token");
      const response = await axios.get(`${baseUrl}/currentauctionpostlist`, {
        params: {
          page: 1,
        },
      });
      // console.log(response.data, ' auction post data ====');
      setAuctionPosts(response?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user posts:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(fetchAuctionPosts, 2000); // Call API every 2 seconds

    return () => {
      clearInterval(intervalId); // Clear interval when component unmounts
    };
  }, []);

  const skeletonNumber = [1, 2, 3, 4, 5, 6, 7, 8];

  return (
    <>
      <div className=" colorBg_new d-none d-lg-block "></div>
      <section className="bg-white newcar-main  text-center  pt-5 pb-2">
        <div className="container">
          <h2 className="text-start section-titles pb-lg-0 text-center text-sm-center text-lg-start">
            FameWheels Live Bidding
          </h2>
          <p className="text-start ">
            FameWheels brings Pakistan's first Live Bidding Portal.
          </p>
        </div>
      </section>
      <div className="container">
        {loading ? (
          <div className="No_ads_loading p-3 text-center my-5">
            <div>
              <div className="row row-gap-4">
                {skeletonNumber.map((index) => (
                  <div key={index} className="col-lg-3">
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width="100%"
                      height={170}
                    />
                    <div>
                      <div className="text-start">
                        <h4 className="mt-3">
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width="80%"
                            height={20}
                          />
                        </h4>
                        <h6>
                          <Skeleton
                            animation="wave"
                            variant="rounded"
                            width="40%"
                            height={20}
                          />
                        </h6>
                      </div>
                      <div className="mb-2">
                        <Skeleton
                          animation="wave"
                          variant="rounded"
                          width="35%"
                          height={8}
                        />
                      </div>
                    </div>
                    <div className="mb-2">
                      <Skeleton
                        animation="wave"
                        variant="rounded"
                        width="55%"
                        height={25}
                      />
                    </div>
                    {/* <div>
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width="100%"
                      height={40}
                    />
                  </div> */}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <BiddingPosts lg={3} md={6} sm={12} xs={12} data={auctionPosts} />
        )}
      </div>
    </>
  );
}
